import type { BackendEntitiesFromBackend } from '../types';

import { URL } from '../../../constants';
import { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

export const getInterestingMatches = (config: ServiceConfig) => {
  type AdapterProps = { response: BackendEntitiesFromBackend };

  return defaultRequestService<AdapterProps>(URL.INTERESTING_MATCHES, config.instance.get);
};
